import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import moment from 'moment';

import { Container, Card, CardBody, Collapse, Button, Form, FormGroup, Label, Input } from 'reactstrap';

import { gameActions } from '../../../actions';

class AdminAddGame extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            gameDate: moment().format('YYYY-MM-DD'),
            gameStartTime: null,
            gameEndTime: null,
            arena: null,
            playerCost: 15,
            goalieCost: 10,
            maxPlayers: 20,
            maxGoalies: 2,
            collapseAdvanced: false
        }
    }

    createGame = () => {
        let {gameDate, gameStartTime, gameEndTime, arena, playerCost, goalieCost, maxPlayers, maxGoalies} = this.state;
        if(gameDate && gameStartTime && gameEndTime && arena && playerCost !== null && goalieCost !== null && maxPlayers && maxGoalies) {
            let gameStartDateMoment = moment(`${gameDate} ${gameStartTime}`);
            let gameEndDateMoment = moment(`${gameDate} ${gameEndTime}`);
            if(gameStartDateMoment.isValid() && gameEndDateMoment.isValid()){
                if(gameStartDateMoment < moment() || gameEndDateMoment < moment()){
                    return false;
                }
                this.props.createGame(gameStartDateMoment, gameEndDateMoment, arena, playerCost, goalieCost, maxPlayers, maxGoalies);
            }
            return false;
        }
        return false;
    }

    onChange = (event) => {
        const {name, value} = event.target;
        this.setState({[name]: value});
    }

    toggleAdvanced = () => {
        this.setState({ collapseAdvanced: !this.state.collapseAdvanced });
    }

    render(){
        return (
            <Container>
                <div className="mt2 mb2">
                    <Form>
                        <FormGroup>
                            <Label for="gameDate">Date</Label>
                            <Input type="date" name="gameDate" id="gameDate" onChange={this.onChange} defaultValue={this.state.gameDate}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="gameStartTime">Start Time</Label>
                            <Input type="time" name="gameStartTime" id="gameStartTime" onChange={this.onChange} defaultValue={this.state.gameStartTime}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="gameEndTime">End Time</Label>
                            <Input type="time" name="gameEndTime" id="gameEndTime" onChange={this.onChange} defaultValue={this.state.gameEndTime}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="arena">Arena</Label>
                            <Input type="text" name="arena" id="arena" onChange={this.onChange} defaultValue={this.state.arena}/>
                        </FormGroup>
                        <Button color="link" onClick={this.toggleAdvanced} style={{ marginBottom: '1rem' }}>{this.state.collapseAdvanced ? 'Hide Advanced' : 'Show Advanced'}</Button>
                        <Collapse isOpen={this.state.collapseAdvanced}>
                            <Card>
                                <CardBody>
                                    <FormGroup>
                                        <Label for="playerCost">Player Credit Cost</Label>
                                        <Input type="text" name="playerCost" id="playerCost" onChange={this.onChange} defaultValue={this.state.playerCost}/>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="goalieCost">Goalie Credit Cost</Label>
                                        <Input type="text" name="goalieCost" id="goalieCost" onChange={this.onChange} defaultValue={this.state.goalieCost}/>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="maxPlayers">Max Players</Label>
                                        <Input type="text" name="maxPlayers" id="maxPlayers" onChange={this.onChange} defaultValue={this.state.maxPlayers}/>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="maxGoalies">Max Goalies</Label>
                                        <Input type="text" name="maxGoalies" id="maxGoalies" onChange={this.onChange} defaultValue={this.state.maxGoalies}/>
                                    </FormGroup>
                                </CardBody>
                            </Card>
                        </Collapse>
                    </Form>
                </div>
                <div className="" style={{width: '100%'}}>
                    <div className="fr mb3">
                        <Button className="mr2" color="primary" onClick={this.createGame}>Create</Button>
                        <Link to='/admin/'>Cancel</Link>
                    </div>
                </div>
            </Container>
        );
    }
}
export default connect(null, gameActions)(AdminAddGame);


// WEBPACK FOOTER //
// ./src/components/Admin/Games/AdminAddGame.js